
import React from 'react';
import { 
    Edit,  
    SimpleForm, 
    TextInput, 
    BooleanInput,
    required
} from 'react-admin';


export const TeamEdit = (props) => {

    return (
    <Edit {...props}>
        <SimpleForm>
            <TextInput disabled label="Id" source="id" />
            <TextInput label="PP id" source="pp_id" validate={required()}/>
            <BooleanInput label="Active" source="is_active" defaultValue />
        </SimpleForm>
    </Edit>)
};